import styled from 'styled-components';
import { RadioBoxGroup } from '../../../common/RadioBox';

/** Tablet width - pre-upgrade value from .continueButtonMinWidth used */
export const StyledWrapper = styled.div`
  ${({ styles }) => styles}
`;

export const mobileQuery = (style) => `@media (max-width: 480px) {${style}}`;
export const nonMobileQuery = (style) => `@media (min-width: 481px) {${style}}`;
export const nonDesktopQuery = (style) => `@media (max-width: 1024px) {${style}}`;
export const tabletOnlyQuery = (style) => `@media (min-width: 768px) and (max-width: 1024px) and (orientation: portrait) {${style}}`;
export const noPadMobile = mobileQuery('padding-left: 0px;padding-right: 0px;');
export const onlyMobilePad = nonMobileQuery('padding-left: 0px;padding-right: 0px;');
export const noPadMobileStrict = mobileQuery('padding-left: 0px !important;padding-right: 0px !important;');
export const fullWidthColsSpan = { xs: 12, sm: 12, md: 12, lg: 12, colSizes: { mobile: 4, tablet: 12, desktop: 12 } };
export const CTAProps = { width: tabletOnlyQuery ? '383px' : '100%' };

export const ShippingOptionsGroup = styled(RadioBoxGroup)`
  margin-top: 30px;
`;

// TODO: need cleanup
export const ShippingDetailsWrapper = styled.div`
  font-weight: 400;
  & * {
    margin: 0px;
  }
  h1,
  h2 {
    font-family: revert;
  }
  h1 {
    font-weight: 300;
    font-size: 32px;
    line-height: 36px;
    ${mobileQuery(`
      font-weight: 700;
      font-size: 24px;
      line-height: 28px;
    `)}
  }
  h2 {
    font-weight: 400;
    font-size: 24px;
    line-height: 28px;
    margin-top: 24px;
    ${mobileQuery('margin-top: 16px;')}
  }
  .headerDesc {
    font-size: 16px;
    line-height: 20px;
    margin-top: 18px;
    ${mobileQuery('margin-top: 20px;')}
  }
  .subHeaderDesc,
  .subHeaderDesc2 {
    font-size: 14px;
    line-height: 18px;
  }
  .subHeaderDesc2 {
    margin-top: 12px;
    ${mobileQuery('margin-top: 16px;')}
  }
`;
